import { Map, Package, Bug, FlaskConical, Calendar, Users } from "lucide-react";

/**
 * `guide_steps.icon` guarda un nombre de icono en texto. Este es el mapa a los
 * componentes reales, compartido por la lista de la guía y por el menú lateral
 * durante la puesta en marcha, para que los dos pinten el mismo icono en cada
 * paso. Si el nombre no está en el mapa, se usa `Map` como respaldo.
 */
export const STEP_ICONS: Record<string, React.ComponentType<{ className?: string }>> = {
  map: Map,
  package: Package,
  bug: Bug,
  "flask-conical": FlaskConical,
  calendar: Calendar,
  users: Users,
};

export const STEP_ICON_FALLBACK = Map;

export function stepIcon(name: string | null | undefined) {
  return (name && STEP_ICONS[name]) || STEP_ICON_FALLBACK;
}
